module.exports = __webpack_public_path__ + "static/img/04.7339cde.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/eggenberger/04.jpg
// module id = 364
// module chunks = 1